<template>
  <div class="emat-textarea">
    <textarea id="textarea" v-model="textInput" placeholder="Geef hier jouw extra wensen aan…"></textarea>
  </div>
</template>

<script>
export default {
  name: 'TextareaInput',

  props: {
    /**
     * Unique name for your input
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * Unique name for your input
     */
    value: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      textInput: this.value,
    };
  },

  watch: {
    textInput: {
      deep: true,
      handler(val) {
        this.onChange(val);
      },
    },
    value: {
      deep: true,
      handler(val) {
        this.textInput = val;
      },
    },
  },

  methods: {
    onChange(val) {
      /**
       * Output the input for v-model
       */
      this.$emit('input', val);

      /**
       * Output the change with the new value
       */
      this.$emit('change', val);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/sass/abstracts";

.emat-textarea {
  padding: 15px 12px 10px 12px;
  display: flex;
  align-content: center;
  justify-content: center;

  textarea {
    border-radius: $border-radius;
    font-family: var(--font);
    font-size: 12px;
    resize: none;
    border: 1px solid rgba(0, 0, 0, 0.1);
    padding: 8px 10px 26px 10px;
    max-height: 60px;
    max-width: 179px;
    width: 100%;

    &:focus, :active {
      outline: none;
    }
  }
}
</style>
